import { Component, OnInit, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { AddEditFollowUpStatusMasterComponent } from './addEditFollowUpStatusMaster.component';
import { FollowUpStatusMasterService } from '../../../services/index';

@Component({
    selector: 'follow-up-status-master-tab',
    templateUrl: './followUpStatusMaster.component.html',
})
export class FollowUpStatusMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoadMask: Promise<any>;
    loadingIndicator = true;

    searchText = '';
    teamData: any[] = [];
    filteredTeamData: any[] = [];
    bsModalRef: BsModalRef;

    teamChipClass: any = {
        'Phone Tracking':          'tc-phone',
        'HV Follow Up':            'tc-hv',
        'SOA Follow Up':           'tc-soa',
        'Sales Follow Up':         'tc-sales',
        'Sold Follow Up':          'tc-sold',
        'Unsold Follow Up':        'tc-unsold',
        'Unsold OCT':              'tc-uoct',
        'After Sales Follow Up':   'tc-after',
        'Store Followup':          'tc-store',
        'Dummy Sales Followup':    'tc-dummy',
        'Old Client Followup':     'tc-oc',
        'Promo Unsold Followup':   'tc-promo',
        'Not Willing Now':         'tc-nwn',
        'Others Followup':         'tc-others',
        'Spares Followup':         'tc-spares',
        'Service Followup':        'tc-service',
        'Camp Promo':              'tc-camp',
        'Trial Not Willing':       'tc-tnw',
        'Bilateral Willing Client':'tc-bwc',
    };

    constructor(
        private followUpStatusMasterService: FollowUpStatusMasterService,
        private modalService: BsModalService
    ) {}

    ngOnInit() {
        this.getTeamList();
    }

    getTeamList() {
        this.isLoadMask = this.followUpStatusMasterService.getTeamList().then((res: any) => {
            this.loadingIndicator = false;
            if (res.success) {
                this.teamData = res.data;
                this.filteredTeamData = res.data;
            }
        });
    }

    getChipClass(team: string): string {
        return this.teamChipClass[team] || 'tc-others';
    }

    applyFilter() {
        const txt = this.searchText.toLowerCase().trim();
        this.filteredTeamData = txt
            ? this.teamData.filter(r => r.team.toLowerCase().includes(txt))
            : this.teamData;
    }

    clearFilter() {
        this.searchText = '';
        this.filteredTeamData = this.teamData;
    }

    getMoreCount(row: any): number {
        return row.count - (row.previewNames ? row.previewNames.length : 0);
    }

    onEdit(row: any) {
        this.bsModalRef = this.modalService.show(AddEditFollowUpStatusMasterComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg'
        });
        this.bsModalRef.content.title   = 'Edit Status Assignment — ' + row.team.toUpperCase();
        this.bsModalRef.content.teamRow = Object.assign({}, row);
        this.bsModalRef.content.loadEvent.subscribe(() => { this.getTeamList(); });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/followUpStatusMaster/followUpStatusMaster.component.ts